import { post, request } from "@insite/client-framework/Services/ApiService";

export interface FreightQuoteRequest {
    emailId: string;
    destAddrLine1: string;
    destAddrLine2?: string;
    destAddrCity: string;
    destAddrState: string;
    destAddrZip: string;
    productNumber: string;
    stockQuantityInHand: number;
    unitNetPrice: number;
    qtyOrdered: number;
    ResidentialAddressIndicator?: boolean
    onSuccess?: (result: FreightQuoteResponse) => void;
    onError?: (error: string) => void;
}

export interface FreightQuoteResponse {
    [key: string]: any;
}

const freightQuoteApi = "/api/v2/freight/GetFreightQuote";

export function getFreightQuote(model: FreightQuoteRequest) {
    return post<FreightQuoteResponse>(`${freightQuoteApi}`, model);
}
